import { render, staticRenderFns } from "./cookie-policy.vue?vue&type=template&id=abef70f6&scoped=true&"
import script from "./cookie-policy.vue?vue&type=script&lang=js&"
export * from "./cookie-policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abef70f6",
  null
  
)

export default component.exports